import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** `clsx` + `tailwind-merge` — resolves conflicting Tailwind classes. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
